<ngx-doc-viewer [url]="document" viewer="pdf"></ngx-doc-viewer>
